// @flow
import React from 'react';
import Datepicker from 'antd/lib/date-picker';
import moment from 'moment';
import styled from 'styled-components';
import Button from 'antd/lib/button/button';

import Spoiler from '../../../../components/ui/Spoiler';
import Grid, {GridItem} from '../../../../components/layout/Grid';
import {Selects} from './../../../../components';
import Field from '../../../../components/card/Field';
import type {Vehicle} from '../../../../lib/types';
import OrgUnitSelect from '../../../../components/OrgUnitSelect';
import {formatDateTimeToISOString} from '../../../../lib/helpers';
import type {ReportVehicleWorkParams} from '../../../../lib/types/reportVehicleWork';

const SpoilerContent = styled.div`
  padding: 16px;
`;
const Footer = styled(GridItem)`
  & > * {
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const {
  BrandsSelect,
  VehicleTypeSelect,
  FuelTypeSelect,
  VehicleSelect
} = Selects;
const { RangePicker } = Datepicker;

type Props = {
  onChangeFilter: (key: $Keys<ReportVehicleWorkParams>, value: any) => void,
  params: ReportVehicleWorkParams,
  cleanParams: () => void,
  applyParams: () => Promise<any>,
  onExport: Function
};

/**
 * Фильтр с параметрами для отчета о работе ТС
 */
export default class Filter extends React.Component<Props> {
  render() {
    const { params, onExport } = this.props;
    return (
      <Spoiler defaultExpanded label="Параметры">
        <SpoilerContent>
          <Grid gutter="16px" media={[{ size: 'lg', cols: 3 }]}>
            <GridItem>
              <Field label="Марка">
                <BrandsSelect
                  value={params.brandId}
                  mode="multiple"
                  onChange={ids => this.props.onChangeFilter('brandId', ids)}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Тип ТС">
                <VehicleTypeSelect
                  value={params.type}
                  selectableGroup
                  onChange={types => this.props.onChangeFilter('type', types)}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Вид первичного топлива">
                <FuelTypeSelect
                  value={params.primaryFuelType}
                  mode="multiple"
                  onChange={fuelTypes =>
                    this.props.onChangeFilter('primaryFuelType', fuelTypes)
                  }
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Вид вторичного топлива">
                <FuelTypeSelect
                  value={params.secondaryFuelType}
                  mode="multiple"
                  onChange={fuelTypes =>
                    this.props.onChangeFilter('secondaryFuelType', fuelTypes)
                  }
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Государственный регистрационный знак ТС">
                <VehicleSelect
                  value={params.vehicleId}
                  optionTitle={(vehicle: Vehicle) => vehicle.licensePlate}
                  mode="multiple"
                  onChange={ids => this.props.onChangeFilter('vehicleId', ids)}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Служба">
                <OrgUnitSelect
                  value={params.orgUnitId}
                  onChange={id => this.props.onChangeFilter('orgUnitId', id)}
                  isFilter={true}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Отчетный период">
                <RangePicker
                  format="DD.MM.YYYY HH:mm"
                  showTime={{
                    format: 'HH:mm',
                    defaultValue: [
                      moment('00:00', 'HH:mm'),
                      moment('23:59', 'HH:mm')
                    ]
                  }}
                  placeholder={['Начало', 'Конец']}
                  value={[
                    params.startDate ? moment.utc(params.startDate) : null,
                    params.endDate ? moment.utc(params.endDate) : null
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    this.props.onChangeFilter(
                      'startDate',
                      formatDateTimeToISOString(startDate, startDateString)
                    );
                    this.props.onChangeFilter(
                      'endDate',
                      formatDateTimeToISOString(endDate, endDateString)
                    );
                  }}
                />
              </Field>
            </GridItem>
            <Footer fullWidth>
              <Button type="primary" onClick={onExport}>
                Экспорт
              </Button>
              <Button type="primary" onClick={this.props.applyParams}>
                Применить
              </Button>
              <Button type="secondary" onClick={this.props.cleanParams}>
                Очистить
              </Button>
            </Footer>
          </Grid>
        </SpoilerContent>
      </Spoiler>
    );
  }
}
